import { useBasicDetailsQueries } from "./useBasicDetailsQueries";

export const useBasicDetails = ({ recipeId }) => {
  const { basicDetailsQuery, downloadRecipe } = useBasicDetailsQueries({
    recipeId,
  });
  return { basicDetailsQuery, downloadRecipe };
};
